<template>
    <b-form>
        <b-form-group
            horizontal
            label="Password"
            label-for="password"
            label-cols="0"
            label-cols-sm="2"
            label-align-sm="right"
            state
            invalid-feedback
            valid-feedback
        >
            <b-form-input
                id="password"
                class="width-full"
                type="password"
                @input.native="emitUpdate"
            />
            <b-form-text id="passwordHelpBlock" class="form-text text-muted text-left">
                Must be 9-20 characters long, contain letters and numbers, and must
                <strong>not</strong> contain emoji.
            </b-form-text>
        </b-form-group>
    </b-form>
</template>

<script>
export default {
    props: {
        password: { type: String, default: null },
    },

    methods: {
        emitUpdate($event) {
            this.$emit(`update:${$event.target.id}`, $event.target.value);
        },
    },
};
</script>
